<app-preloader *ngIf="isLoading"></app-preloader>
<!-- MODAL PARA SELECCIONAR PRODUCTOS -->
<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <div class="d-flex flex-row gap-2 align-items-center">
    <h1 style="margin-bottom: 0px">Seleccionar {{ modelType.description }}</h1>
    <span
      *ngIf="classification != undefined && classification != null"
      class="tag align-items-center justify-content-center"
      style="width: 75px"
      >{{ !!(classification == true) ? "Nuevo" : "Usado" }}</span
    >
  </div>

  <div class="seleccionarProductos">
    <form>
      <div class="filters">
        <ng-container>
          <div class="wrapperG3">
            <div class="controlWrapper">
              <label>Nombre</label>
              <app-input
                [data]="searchName"
                (textSearch)="filter($event, 'name')"
                [resetInput]="reset"
              ></app-input>
            </div>
            <div class="controlWrapper">
              <label>Marca</label>
              <app-select
                [options]="this.brands"
                [placeholder]="'Buscar por marca'"
                [resetSelect]="reset"
                (optionSelected)="filter($event, 'brandId')"
              ></app-select>
            </div>
            <div class="controlWrapper">
              <label>Submarca</label>
              <app-select
                [options]="this.subBrandsFiltered"
                [placeholder]="'Buscar por submarca'"
                [resetSelect]="reset"
                (optionSelected)="filter($event, 'subBrandId')"
              ></app-select>
            </div>
          </div>
          <div class="wrapperG3">
            <div class="controlWrapper">
              <label>Año</label>
              <app-select
                [options]="this.years"
                [placeholder]="'Buscar por año'"
                [resetSelect]="reset"
                (optionSelected)="filter($event, 'year')"
              ></app-select>
            </div>

            @if(classification == null || undefined) {
            <div class="controlWrapper">
              <!-- Nuevo select condición-->
              <label>Condición</label>
              <app-select
                [options]="this.conditions"
                [placeholder]="'Buscar por condición'"
                [resetSelect]="reset"
                (optionSelected)="filter($event, 'classification')"
              >
              </app-select>
            </div>
            }
            <div class="wrapperG2">
              <label class="switch gapTop">
                <input
                  (change)="toggleOnlyCheckedModels($event)"
                  [checked]="this.onlyCheckedModels"
                  type="checkbox"
                  checked
                />
                <span class="knob"></span>
                <span class="base"></span>
                <span class="description">Solo seleccionados</span>
              </label>
              <div class="filtersActions">
                <button
                  (click)="resetFilters()"
                  class="secondary clear"
                  tp="Limpiar filtros"
                >
                  Limpiar filtros
                </button>
                <button class="primary search" (click)="search()" tp="Buscar">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Tabla para listado de notificaciones -->
      <div class="customTable seleccionarProductos">
        <div class="header">
          <div class="cell seleccion" *ngIf="models?.length! > 0">
            @if (getVisibleSelectedCount() === 0) {
            <label class="checkboxWrapper" data-filter-type="first-checkbox">
              <input (click)="checkAllModels($event)" type="checkbox" />
              <span class="checkmark"> </span>
            </label>
            } @else if (getVisibleSelectedCount() > 0 && getVisibleSelectedCount() < showAmount(models)) {
            <label class="checkboxWrapper" data-filter-type="second-checkbox">
              <a (click)="checkAllModels($event)" class="checkmark undefined">
              </a>
            </label>
            } @else {
            <label class="checkboxWrapper" data-filter-type="third-checkbox">
              <input
                (click)="uncheckAllModels($event)"
                type="checkbox"
                checked
              />
              <span class="checkmark"> </span>
            </label>
            }
          </div>
          <div class="cell nombre">Nombre</div>
          <div class="cell marca">Marca</div>
          <div class="cell submarca">Submarca</div>
          <div class="cell anio">Año</div>
          <div class="cell condicion">Condición</div>
          <div class="cell estado">Estado</div>
        </div>
        <div class="rowsWrapper">
          @for (model of models; track model) {
          <div class="row">
            <div class="cell seleccion">
              <label class="checkboxWrapper">
                <input
                  [checked]="model.isChecked"
                  (click)="addModel($event, model)"
                  type="checkbox"
                  name="item"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="cell nombre">{{ model.name }}</div>
            <div class="cell marca">{{ model.brand }}</div>
            <div class="cell submarca">{{ model.subBrand }}</div>
            <div class="cell anio">{{ model.year }}</div>
            <div class="cell condicion">
              {{ model.classification ? "Nuevo" : "Seminuevo" }}
            </div>
            <div class="cell estado">
              {{ model.enabled ? "Activo" : "Inactivo" }}
            </div>
          </div>
          }
        </div>
      </div>
      <div class="itemsInfo">
        {{ getVisibleSelectedCount() }} de
        {{ showAmount(models) }} seleccionados
      </div>
      <!-- Acciones para modal condición -->
      <div class="actions">
        <div class="wrapper">
          <button (click)="close()" type="button" class="secondary">
            Cancelar
          </button>
          <button (click)="closeAndSave()" type="submit" class="primary">
            Aceptar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
